import React from 'react';
import Slider from 'react-slick';
import SliderItem from '../components/SliderItem';
// import bg01 from '../assets/images/slider/1.jpg';
// import bg02 from '../assets/images/slider/2.jpg';
// import bg03 from '../assets/images/slider/3.jpg';

const AllSlider = () => {
    const SliderData = [
        {
            id: '1',
            bg: 'images/slider/1.jpg',
            text: 'Exotic and Delicious',
        },
        {
            id: '2',
            bg: 'images/slider/2.jpg',
            text: 'Exotic and Delicious',
        },
        {
            id: '3',
            bg: 'images/slider/3.jpg',
            text: 'Exotic and Delicious',
        },
    ];

    const settings = {
        infinite: false,
        speed: 500,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        vertical: true,
        verticalSwiping: true,
    };

    return (
        <div className="theme_slider_1">
            <div className="slider_slick">
                <Slider {...settings}>
                    {
                        SliderData.map(data => <SliderItem
                            key={data.id}
                            data={data}
                        />)
                    }
                </Slider>
            </div>
        </div>
    );
};

export default AllSlider;
